<!-- Loading -->
<ng-container *ngIf="!ready">
  <div class="sc-loading">
    <div class="sc-loading__dots"><span></span><span></span><span></span></div>
  </div>
</ng-container>

<ng-container *ngIf="ready">

  <!-- Header -->
  <div class="dlg-hdr">
    <div class="dlg-hdr__title">
      <div class="dlg-hdr__icon-wrap">
        <mat-icon>show_chart</mat-icon>
      </div>
      <div>
        <span>{{ uid ? 'Editar capital social' : 'Nuevo capital social' }}</span>
        <small class="dlg-hdr__sub" *ngIf="flagImport">Importación: {{ movement?.reference }}</small>
        <small class="dlg-hdr__sub" *ngIf="!flagImport && !uid">Registra una aportación o ampliación</small>
        <small class="dlg-hdr__sub" *ngIf="!flagImport && uid">Modifica los datos del movimiento</small>
      </div>
    </div>
    <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <mat-dialog-content class="sc-body">

    <!-- Importación banner -->
    <div class="sc-import-banner" *ngIf="flagImport">
      <mat-icon>file_download</mat-icon>
      <div>
        <span class="sc-import-banner__label">Título de importación</span>
        <span class="sc-import-banner__value">{{ movement?.reference }}</span>
      </div>
    </div>

    <div class="row g-3">

      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Importe</mat-label>
          <mat-icon matPrefix>attach_money</mat-icon>
          <input type="number" matInput [formControl]="amountFormControl" placeholder="0.00">
          <span matSuffix class="sc-suffix">€</span>
        </mat-form-field>
      </div>

      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Prima de emisión</mat-label>
          <mat-icon matPrefix>attach_money</mat-icon>
          <input type="number" matInput [formControl]="sharePremiumFormControl" placeholder="0.00">
          <span matSuffix class="sc-suffix">€</span>
        </mat-form-field>
      </div>

      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fecha de Constitución / Ampliación</mat-label>
          <mat-icon matPrefix>event</mat-icon>
          <input matInput [matDatepicker]="date" weekStart=1 required
            [formControl]="dateIncorporationOrExtensionFormControl">
          <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
          <mat-datepicker #date></mat-datepicker>
        </mat-form-field>
        <app-help key='Gastos14'></app-help>
      </div>

    </div>
  </mat-dialog-content>

  <!-- Actions -->
  <mat-dialog-actions align="end" class="dlg-actions">
    <button mat-stroked-button type="button" (click)="closeDialog()">Cancelar</button>
    <button mat-flat-button class="sc-btn-save" type="button" (click)="onSubmit()" [disabled]="submitted">
      <mat-icon>save</mat-icon>
      {{ uid ? 'Guardar cambios' : 'Crear registro' }}
    </button>
  </mat-dialog-actions>

</ng-container>
